import React, { useContext, useEffect, useMemo } from 'react';
import { AuthContext } from '../context/AuthContext';

export const usePermissions = (groupName) => {
    const { state: authState } = useContext(AuthContext);
    const [hasPermissions, setHasPermissions] = React.useState(false);
    const sessionGroups = useMemo(
        () => authState.user.signInUserSession.accessToken.payload['cognito:groups'] || [],
        [authState.user.signInUserSession.accessToken.payload]
    );
    useEffect(() => {
        if (groupName) {
            setHasPermissions(sessionGroups.includes(groupName));
        } else {
            setHasPermissions(true);
        }
    }, [groupName, sessionGroups]);

    return hasPermissions;
};
